import { Link } from 'react-router-dom';
import RoleGate from '@/components/RoleGate';

const ENTRIES = [
  { icon: 'ri-search-line', title: '会员查询', desc: '依 Email 查找会员与基本状态（建设中）' },
  { icon: 'ri-hand-coin-line', title: '会员点数补偿', desc: '人工补点与备注（建设中）' },
  { icon: 'ri-list-check-2', title: '任务状态摘要', desc: '会员生成任务友善摘要（建设中）' },
  { icon: 'ri-megaphone-line', title: '公告 / 私讯通知', desc: '发送会员通知（建设中）' },
  { icon: 'ri-shield-check-line', title: '风控建议', desc: '高风险内容建议，不含完整词库（建设中）' },
  { icon: 'ri-chat-quote-line', title: '话术建议', desc: '回复话术建议，不含模板编辑（建设中）' },
];

export default function SupportConsolePage() {
  return (
    <RoleGate allow={['admin']} deniedTitle="此页仅限会员支持管理员">
      <div className="max-w-4xl mx-auto px-4 py-10">
        <div className="flex items-center gap-2 text-xs text-secondary-400 mb-2">
          <Link to="/" className="hover:text-foreground-600">工作台</Link>
          <i className="ri-arrow-right-s-line" />
          <span>会员支持控制台</span>
        </div>
        <h1 className="text-2xl font-bold text-foreground-950">Member Support Console</h1>
        <p className="text-sm text-foreground-600 mt-1 mb-6">会员查询、补点与任务摘要。不含 Provider raw、帐务完整页与技术诊断。</p>
        <div className="grid sm:grid-cols-2 gap-3">
          {ENTRIES.map((e) => (
            <div key={e.title} className="rounded-xl border border-secondary-200 bg-background-50 p-4">
              <div className="flex items-center gap-2 text-sm font-semibold text-foreground-900">
                <i className={`${e.icon} text-primary-500`} />
                {e.title}
              </div>
              <p className="text-xs text-secondary-500 mt-2">{e.desc}</p>
              <span className="inline-block mt-3 text-[10px] px-2 py-0.5 rounded bg-secondary-100 text-secondary-500">建设中</span>
            </div>
          ))}
        </div>
      </div>
    </RoleGate>
  );
}
